import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  updateSkillsFramework,
  UpdateSkillsFrameworkData
} from "PFCore/services/skills_frameworks/update_skills_framework";
import { MutationOptions } from "PFTypes/request_options";

import { skillsFrameworksKeys } from "./query_keys";

type UseSkillsFrameworkUpdate = {
  options?: MutationOptions<UpdateSkillsFrameworkData>;
};

export const useSkillsFrameworkUpdate = ({ options = {} }: UseSkillsFrameworkUpdate = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateSkillsFramework,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({
        queryKey: skillsFrameworksKeys.list()
      });
      queryClient.setQueryData(skillsFrameworksKeys.single(args[0].id), args[0]);
      options.onSuccess?.(...args);
    },
    ...options
  });
};
